/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Type_LabelInputs */



/**
* | output |
* | --- |
* | "Type:" |
*
* @param {Preset_Manager_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_type_label = /** @type {((inputs?: Preset_Manager_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Typ:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("类型：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイプ：")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकार:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo:")
	return /** @type {LocalizedString} */ ("Type:")
});